export const ROUTE_DOCUMENTS = 'ROUTE_DOCUMENTS'
export const ROUTE_DOCUMENT_EDIT = 'ROUTE_DOCUMENT_EDIT'
export const ROUTE_DOCUMENT_VIEW = 'ROUTE_DOCUMENT_VIEW'
export const ROUTE_DOCUMENT_CREATE = 'ROUTE_DOCUMENT_CREATE'
export const MATERIA_DE_INTERNET = 391
